import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

function Card({ i, total, title, desc, progress }) {
  const start = i / total;
  const end = (i + 1) / total;
  const scale = useTransform(progress, [start, 1], [1, 1 - (total - 1 - i) * 0.04]);
  const dim = useTransform(progress, [end, Math.min(1, end + 0.2)], [0, 0.35]);
  const palette = [
    "bg-surface text-ink",
    "bg-tint2 text-ink",
    "bg-pine text-white [&_h3]:text-white",
    "bg-ink text-white [&_h3]:text-white",
  ];
  return (
    <motion.article
      style={{ scale, top: `calc(14vh + ${i * 28}px)` }}
      className={`sticky mx-auto mb-10 flex min-h-[58vh] max-w-5xl flex-col justify-between rounded-[10px] border border-line/60 p-8 shadow-[0_30px_80px_-40px_rgba(18,33,27,0.45)] md:p-14 ${palette[i % 4]}`}
      data-testid={`commitment-${i}`}
    >
      <motion.div style={{ opacity: dim }} className="pointer-events-none absolute inset-0 bg-ink" aria-hidden />
      <div className="flex items-start justify-between">
        <span className="font-display text-6xl font-bold leading-none text-terra md:text-7xl">0{i + 1}</span>
        <img src="/brand/leaf.png" alt="" aria-hidden className="h-10 w-10 object-contain opacity-70" />
      </div>
      <div>
        <h3 className="font-display text-3xl font-semibold leading-tight md:text-5xl">{title}</h3>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed opacity-80">{desc}</p>
      </div>
    </motion.article>
  );
}

export default function StackCards({ items }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  return (
    <div ref={ref} className="relative px-6 md:px-10">
      {items.map(([title, desc], i) => (
        <Card key={i} i={i} total={items.length} title={title} desc={desc} progress={scrollYProgress} />
      ))}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: EASE }}
        className="h-[10vh]"
      />
    </div>
  );
}
